import React, { useState } from "react";
import {
  Modal,
  StyleSheet,
  View,
  Image,
  TouchableNativeFeedback,
  TouchableOpacity,
} from "react-native";
import Text from "@components/AppText";
import { normalize, width, height } from "../../constants/metrics";
import WhatsappDefault from "../../assets/svg/WhatsappDefault";
import AppText from "../AppText";
import CloseIcon from "../../assets/svg/CloseIcon";

const ZoomImageShare = (props) => {
  const {
    visible,
    imageUrl = "",
    toggleBanner = () => {},
    handleShare = () => {},
  } = props;
  const [viewHeight, setViewHeight] = useState(0);

  const handleViewLayout = ({
    nativeEvent: {
      layout: { x: X, y, width, height },
    },
  }) => {
    setViewHeight(height);
  };

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      transparent={true}
      animationType="slide"
      visible={visible}
      onRequestClose={toggleBanner}
    >
      <View
        style={{
          flex: 1,
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          paddingVertical: 36,
          paddingHorizontal: 15,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: normalize(12),
            width: "100%",
          }}
        >
          <TouchableOpacity onPress={toggleBanner}>
            <CloseIcon width={20} height={20} fill={"#fff"} />
          </TouchableOpacity>
          <Text style={styles.textHeader}>अपने कस्टमर से शेयर करें</Text>
        </View>
        <View
          onLayout={handleViewLayout}
          style={{
            flex: 1,
            marginBottom: normalize(22),
          }}
        >
          <Image
            resizeMode="contain"
            source={{
              uri: imageUrl,
            }}
            style={{
              width: width - 30,
              height: viewHeight,
            }}
            width={112}
            height={146}
          />
        </View>
        <TouchableNativeFeedback onPress={handleShare}>
          <View
            style={{
              backgroundColor: "#23CF5F",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 10,
              width: "100%",
            }}
          >
            <View style={[styles.wrapper, {}]}>
              <View
                style={{
                  paddingRight: 6,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <WhatsappDefault size={28} />
              </View>
              <View>
                <AppText
                  style={{ color: "#fff", fontSize: normalize(20) }}
                  bold
                >
                  शेयर करें
                </AppText>
              </View>
            </View>
          </View>
        </TouchableNativeFeedback>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  textHeader: {
    fontSize: normalize(24),
    lineHeight: normalize(32),
    fontWeight: "bold",
    color: "#fff",
    flex: 1,
    textAlign: "center",
  },
  wrapper: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: normalize(8),
  },
});

export default ZoomImageShare;
